export type ThreadMessageType = 'MESSAGE' | 'ACTION_FILE_UPLOAD';

export const ThreadMessageType = {
  MESSAGE: 'MESSAGE' as ThreadMessageType,
  ACTIONFILEUPLOAD: 'ACTION_FILE_UPLOAD' as ThreadMessageType,
};
